import { ApiResponse } from '@shared/types';
import { PaymentMethodRecord } from '../types/accounting';
import { supabase } from './supabase';

const mapPaymentMethod = (
  value: Record<string, unknown>,
): PaymentMethodRecord => ({
  id: Number(value.id || 0),
  name: String(value.name || ''),
  type: value.type as PaymentMethodRecord['type'],
});

export const fetchPaymentMethods = async (): Promise<
  ApiResponse<PaymentMethodRecord[]>
> => {
  try {
    const { data, error } = await supabase
      .from('payment_methods')
      .select('*')
      .order('name', { ascending: true });

    if (error) {
      return { success: false, error: error.message, data: [] };
    }

    return {
      success: true,
      data: (data || []).map((item) => mapPaymentMethod(item)),
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to fetch payment methods',
      data: [],
    };
  }
};
